<template>
  <div>
    <section>
      <header>
        <el-breadcrumb>
          <!--        组织架构-->
          <el-breadcrumb-item>{{
            $t("message.organizationalStructure")
          }}</el-breadcrumb-item>
          <!--        角色列表-->
          <el-breadcrumb-item>{{
            $t("message.theRoleList")
          }}</el-breadcrumb-item>
          <!--        '新增角色':'编辑角色'-->
          <el-breadcrumb-item>{{
            JSON.stringify($route.query) === "{}"
            ? $t("message.theNewRole")
            : $t("message.editingTheRole")
          }}</el-breadcrumb-item>
        </el-breadcrumb>
      </header>
      <footer>
        <div class="footerText">
          {{
            JSON.stringify($route.query) === "{}"
            ? $t("message.theNewRole")
            : $t("message.editingTheRole")
          }}
        </div>
        <el-form ref="ruleForm" :model="ruleForm" :rules="rules" class="demo-ruleForm" label-width="160px">
          <!--        角色名称：-->
          <el-form-item :label="$t('message.newCharacterName')" prop="name">
            <el-input v-model="ruleForm.name" style="width: 488px"
              :placeholder="$t('message.pleaseEnterARoleName')"></el-input>
            <!--          请输入角色名称-->
          </el-form-item>
          <!--        工种：-->
          <el-form-item :label="$t('message.newTypeOfWork')" prop="work_type">
            <!--            工种选择-->
            <el-select v-model="ruleForm.work_type" :placeholder="$t('message.typeOfWorkToChoose')" style="width: 488px">
              <el-option v-for="item in worktypeData" :key="item.id" :label="item.work_name" :value="item.id">
              </el-option>
            </el-select>
            <!--          请输入系统账号-->
          </el-form-item>
          <!--        部门：-->
          <el-form-item :label="$t('message.department')" prop="org_id">
            <el-cascader :options="organizationData" v-model="ruleForm.org_id" style="width: 488px" :props="{
              checkStrictly: true,
              label: 'name',
              children: 'childs',
              expandTrigger: 'hover',
              value: 'id',
            }" clearable :placeholder="$t(
  'message.clickTheDepartmentOptionToSearchAndDisplayTheCurrentDepartmentByDefault'
)
  " @change="getValue"></el-cascader>
            <!--      点击部门选项，可以搜索，默认显示当前部门-->
          </el-form-item>
          <!--        聊天群组：-->
          <el-form-item :label="$t('message.newChatGroup')" prop="auto_chat">
            <el-radio v-model="ruleForm.auto_chat" :label="1">{{
              $t("message.automaticallyJoiningAGroup")
            }}</el-radio><!--自动加入群组-->
            <el-radio v-model="ruleForm.auto_chat" :label="0">{{
              $t("message.doNotAutomaticallyJoinGroups")
            }}</el-radio><!--不自动加入群组-->
          </el-form-item>
        </el-form>
        <div class="flexAndCenter" style="margin-top: 48px">
          <!--        保存-->
          <el-button @click="submitAddAccountNumber" type="primary" style="margin: 0 16px 0 40px">{{ $t("message.save")
          }}</el-button>
          <!--        返回-->
          <el-button @click="$router.go(-1)">{{
            $t("message.return")
          }}</el-button>
        </div>
      </footer>
    </section>
  </div>
</template>
<script>
export default {
  name: "index",
  data() {
    return {
      organizationData: [],
      worktypeData: [],
      is_transient: "",
      ruleForm: {
        name: "",
        org_id: "",
        work_type: "",
        auto_chat: 0,
      },
    };
  },

  computed: {
    rules() {
      return {
        name: {
          required: true,
          message: this.$t("message.pleaseEnterARoleName"),
          trigger: "blur",
        }, //请输入角色名称
        org_id: {
          required: true,
          message: this.$t("message.pleaseSelectTheTypeOfWork"),
          trigger: "change",
        }, //请选择工种
        work_type: {
          required: true,
          message: this.$t("message.pleaseSelectDepartment"),
          trigger: "change",
        }, //请选择部门
      };
    },
  },
  created() {
    if (JSON.stringify(this.$route.query) !== "{}") {
      let query = this.$route.query
      // this.getRoleList();
      this.ruleForm = {
        name: query.searchText,
        org_id: query.id - 0,
        work_type: query.workType - 0,
        auto_chat: query.auto_chat - 0,
      }
    }
    this.getOrganizationList();
    this.getWorktypeList();
  },
  methods: {
    //部门数据获取
    getOrganizationList() {
      this.$api.roleApi.organizationList().then((res) => {
        this.organizationData = res.data;
      });
    },
    //工种类型获取
    getWorktypeList() {
      this.$api.roleApi.worktypeList().then((res) => {
        this.worktypeData = res.data;
      });
    },
    //更新角色部门
    getValue(e) {
      this.ruleForm.org_id = e[e.length - 1];
    },
    //提交添加的账号
    submitAddAccountNumber() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (JSON.stringify(this.$route.query) === "{}") {
            //是否添加该角色                           提示
            this.$confirm(
              this.$t("message.whetherToAddTheRole"),
              this.$t("message.hint"),
              {
                confirmButtonText: this.$t("message.confirm"), //确定
                cancelButtonText: this.$t("message.cancel"), //取消
                type: "warning",
                center: true,
              }
            )
              .then(() => {
                this.$api.roleApi.addRole(this.ruleForm).then((res) => {
                  this.$message.success(res.msg);
                  setTimeout(() => {
                    this.$router.go(-1);
                  }, 1000);
                });
              })
              .catch((err) => {
                this.$message({
                  type: "info",
                  message: this.$t("message.theAdditionHasBeenCanceled"), //已取消添加
                });
              });
          } else {
            //是否修改该角色的信息                           提示
            this.$confirm(
              this.$t("message.whetherToModifyTheRole"),
              this.$t("message.hint"),
              {
                confirmButtonText: this.$t("message.confirm"), //确定
                cancelButtonText: this.$t("message.cancel"), //取消
                type: "warning",
                center: true,
              }
            )
              .then(() => {
                console.log(this.ruleForm);
                this.ruleForm.id = this.$route.query.id;

                this.$api.roleApi.editRole(this.ruleForm).then((res) => {
                  this.$message.success(res.msg);
                  setTimeout(() => {
                    this.$router.go(-1);
                  }, 1000);
                });
              })
              .catch((err) => {
                this.$message({
                  type: "info",
                  message: this.$t("message.modificationCancelled"), //已取消修改
                });
              });
          }
        }
      });
    },
    //获取角色详情
    getRoleList() {
      this.$api.roleApi
        .roleList({
          searchText: this.$route.query.searchText,
          workType: this.$route.query.work_type,
        })
        .then((res) => {
          console.log(res);
          this.ruleForm = {
            name: res.data.data[0].name,
            org_id: res.data.data[0].org_id,
            work_type: res.data.data[0].work_type.work_type,
            auto_chat: res.data.data[0].auto_chat,
          };
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.flexAndCenter {
  display: flex;
  align-items: center;
}

section {
  border-radius: 8px;
  display: flex;
  flex-direction: column;

  header {
    border-radius: 8px;
    background: #f8f8f8;
    padding: 24px;
    margin-bottom: 24px;
  }

  footer {
    border-radius: 8px;
    background: #f8f8f8;
    padding: 24px;

    .footerText {
      color: #999999;
      margin-bottom: 30px;
    }
  }
}
</style>